
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.6 12.193l.102-.404.151.202h2.372l.202-.707v-.454s-.05-.202-.354-.202h-2.27l.353-2.775h1.06s.252.555.353.555c.1 0 .353-.555.353-.555h4.541s.202-.05.202-.202c.05-.151.152-.807.152-1.009 0-.202-.101-.504-.303-.504H9.872v-.455s-.05-.302-.253-.302h-.05V5.28s1.06.05 1.06-.05c0-.051-1.06-.051-1.06-.051s0-.202-.05-.202-.051.202-.051.202-1.06 0-1.06.05 1.06.05 1.06.05v.051h-.101c-.202 0-.252.303-.252.303v.454h-.909V4.372s-.15-1.565-.706-1.565-.706 1.565-.706 1.565v1.715h-.909v-.454s-.05-.303-.252-.303h-.1v-.05s1.059.05 1.059-.05-1.06-.051-1.06-.051 0-.202-.05-.202-.05.202-.05.202-1.06 0-1.06.05 1.06.05 1.06.05v.051H5.38c-.202 0-.253.303-.253.303v.454H.486c-.202 0-.303.303-.303.505S.335 7.45.335 7.6a.969.969 0 00.403.252H5.28s.252.555.353.555c.1 0 .353-.555.353-.555h1.06l.353 2.775H5.13c-.253 0-.354.202-.354.202v.454l.202.707h2.372l.151-.202.1.404z"}})])
          )
        }
      }
    